// src/components/FAQ.jsx
import React from 'react';

export default function FAQ({ language }) {
  const titles = {
    es: "Preguntas Frecuentes",
    en: "FAQs",
    pt: "Perguntas Frequentes"
  };

  return (
    <section id="faq" className="bg-[#48887B] py-12 scroll-mt-32 text-center">
      <h2 className="text-white text-3xl md:text-5xl font-bold text-center">
        {titles[language]}
      </h2>
    </section>
  );
}
